import __request__ from "routing/request";
export function listStatuses(sort = "category", page = 1, per_page = 15, query, direction = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets/categories", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "direction": direction }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(Category, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/assets/categories", Category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/assets/categories/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, Category, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp/assets/categories/${id}`, Category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp/assets/categories/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
